import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
export function Card({ children, icon, subtitle, title, header, className, variant = "bordered", ...props }) {
    const hasHeader = title || subtitle || icon || header;
    return /*#__PURE__*/ _jsxs("div", {
        className: clsx("rounded-lg bg-white", variant === "bordered" && "border border-gray-200", variant === "default" && "shadow-sm", className),
        ...props,
        children: [
            hasHeader && /*#__PURE__*/ _jsxs("div", {
                className: clsx("border-b border-gray-200 flex items-center p-4 md:p-6", variant === "bordered" ? "bg-gray-50 rounded-t-lg" : "bg-white"),
                children: [
                    icon && /*#__PURE__*/ _jsx("div", {
                        className: "bg-gray-100 p-3 rounded-full mr-4 flex items-center justify-center",
                        children: icon
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex-1",
                        children: [
                            title && /*#__PURE__*/ _jsx("h3", {
                                className: "text-lg font-semibold text-gray-900 md:text-xl",
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ _jsx("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "font-bold text-2xl text-gray-900 md:text-3xl",
                                    children: subtitle
                                })
                            })
                        ]
                    }),
                    header && /*#__PURE__*/ _jsx("div", {
                        className: "ml-4",
                        children: header
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "p-4 md:p-6",
                children: children
            })
        ]
    });
}
